type HttpErrorMessages = {
  [status: number]: Record<string, string>;
  xxx?: Record<string, string>;
};

function httpErrorMessagesFetcher(
  errorMessages: HttpErrorMessages,
  status: number | undefined,
  httpErrorMessage: string | undefined,
): string | null {
  if (!httpErrorMessage) return null;
  const codeMessages: Record<string, string> = {
    ...(status === undefined ? {} : errorMessages[status]),
    ...errorMessages.xxx,
  };
  if (Object.keys(codeMessages).length === 0) return null;
  return (httpErrorMessage && codeMessages[httpErrorMessage]) || null;
}

export { httpErrorMessagesFetcher };
